import { FreightDeliveryAccessorialPresetRowSchema } from "@redotech/redo-fulfillment-common/freight/freight-delivery-accessorial-preset";
import * as z from "zod";

export const getFreightDeliveryAccessorialPresets = {
  name: "getFreightDeliveryAccessorialPresets" as const,
  input: z.object({}),
  output: z.object({
    presets: z.array(FreightDeliveryAccessorialPresetRowSchema),
  }),
};
